document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-search-drawer]');
  const input = document.querySelector('[data-predictive-input]');
  const resultsBox = document.querySelector('[data-predictive-results]');
  const recentBox = document.querySelector('[data-recent-searches]');
  const toggleBtns = document.querySelectorAll('[data-search-toggle]');

  let debounceTimer = null;
  let activeIndex = -1;
  let items = [];

  // const RECENT_KEY = 'hz_recent_searches';

  /* ------------------------
     Drawer toggle
  ------------------------ */
  toggleBtns.forEach(btn =>
    btn.addEventListener('click', () => {
      drawer.classList.toggle('is-open');
      if (drawer.classList.contains('is-open')) {
        setTimeout(() => {
          input.readOnly = true;
          input.readOnly = false;
          input.focus();
          renderRecent();
        }, 100);
      }
    })
  );

  /* ------------------------
     Recent searches
  ------------------------ */
  // function getRecent() {
  //   return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
  // }

  // function saveRecent(term) {
  //   let recent = getRecent();
  //   recent = recent.filter(t => t !== term);
  //   recent.unshift(term);
  //   recent = recent.slice(0, 3);
  //   localStorage.setItem(RECENT_KEY, JSON.stringify(recent));
  // }

  // function renderRecent() {
  //   const recent = getRecent();

  //   if (!recent.length) {
  //     recentBox.innerHTML = '';
  //     return;
  //   }

  //   recentBox.innerHTML = `
  //     <div class="hz-recent-title">Recent searches</div>
  //     ${recent
  //       .map(
  //         term =>
  //           `<div class="hz-recent-item" data-term="${term}">${term}</div>`
  //       )
  //       .join('')}
  //   `;

  //   recentBox.querySelectorAll('.hz-recent-item').forEach(item => {
  //     item.addEventListener('click', () => {
  //       input.value = item.dataset.term;
  //       fetchResults(item.dataset.term);
  //     });
  //   });
  // }


  const RECENT_PRODUCTS_KEY = 'hz_recent_products';

  function getRecentProducts() {
    return JSON.parse(localStorage.getItem(RECENT_PRODUCTS_KEY) || '[]');
  }

  function renderRecent() {
    const products = getRecentProducts();

    if (!products.length) {
      recentBox.innerHTML = '';
      return;
    }

    recentBox.innerHTML = `
      <div class="hz-recent-title">Recently viewed</div>
      ${products
        .map(
          p => `
          <a href="${p.url}" class="hz-recent-item hz-recent-product">
            ${p.image ? `<img src="${p.image}" />` : ''}
            <span class="hz-recent-title">${p.title}</span>
          </a>
          `
        )
        .join('')}
    `;
  }


  /* ------------------------
     Debounced input
  ------------------------ */
  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);

    const query = input.value.trim();
    if (!query) {
      resultsBox.innerHTML = `<p class="hz-search-hint">Start typing to search…</p>`;
      renderRecent();
      return;
    }

    debounceTimer = setTimeout(() => {
      fetchResults(query);
    }, 300);
  });

  /* ------------------------
     Fetch predictive results
  ------------------------ */
  async function fetchResults(query) {
    const url = `/search/suggest.json?q=${encodeURIComponent(
      query
    )}&resources[type]=product,collection&resources[limit]=4&resources[options][fields]=title,product_type`;

    const res = await fetch(url);
    const data = await res.json();

    // saveRecent(query);
    renderResults(data.resources.results);
  }

  /* ------------------------
     Render results
  ------------------------ */
  function renderResults(results) {
    activeIndex = -1;
    items = [];
    recentBox.innerHTML = '';

    let html = '';

    if (results.products?.length) {
      html += `<div class="hz-search-section">
        <h4>Products</h4>`;

      results.products.forEach(p => {
        const img = p.image
          ? `<img src="${p.image}" class="hz-search-thumb" />`
          : '';

        html += `
        <a href="${p.url}" class="hz-search-item" data-index="${items.length}">
          ${img}
          <span>${p.title}</span>
        </a>

        `;
        items.push(p.url);
      });

      html += `</div>`;
    }

    if (results.collections?.length) {
      html += `<div class="hz-search-section">
        <h4>Collections</h4>`;

      results.collections.forEach(c => {
        html += `
          <div class="hz-search-item" data-index="${items.length}">
            <a href="${c.url}">${c.title}</a>
          </div>
        `;
        items.push(c.url);
      });

      html += `</div>`;
    }

    if (!html) {
      html = `<p class="hz-search-hint">No results found</p>`;
    }

    const query = input.value.trim();

    if (query) {
      html += `
        <div class="hz-search-show-all">
          <a href="/search?q=${encodeURIComponent(query)}&type=product">
            Show all results
          </a>
        </div>
      `;
    }


    resultsBox.innerHTML = html;
  }

  /* ------------------------
     Keyboard navigation
  ------------------------ */
  input.addEventListener('keydown', (e) => {
    const resultItems = resultsBox.querySelectorAll('.hz-search-item');
    if (!resultItems.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIndex = (activeIndex + 1) % resultItems.length;
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIndex =
        (activeIndex - 1 + resultItems.length) % resultItems.length;
    }

    if (e.key === 'Enter') {
      e.preventDefault();

      const query = input.value.trim();

      if (activeIndex >= 0) {
        window.location.href = items[activeIndex];
      } else if (query) {
        window.location.href = `/search?q=${encodeURIComponent(query)}&type=product`;
      }
    }


    if (e.key === 'Escape') {
      drawer.classList.remove('is-open');
    }

    resultItems.forEach(el => el.classList.remove('is-active'));
    if (activeIndex >= 0) {
      resultItems[activeIndex].classList.add('is-active');
    }
  });
});
